import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

      <ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="subPageContainer">

          <Typography variant='h1' className='sectionTitle'>Erben und Vererben</Typography>

          <Box className='subpageBodyBox'>

            <Typography variant='h2' className='sectionTitle2 subsection'>Das Erbe regeln</Typography>
            <Typography variant='body1' className='sectionText textTwoColumns'>
              Wenn jemand seine Erbfolge nicht regelt, gilt automatisch die gesetzliche Erbfolge. Demnach erhalten die nächsten Verwandten des Verstorbenen dessen gesamtes Vermögen. Es spielt keine Rolle, wie das Verhältnis zwischen den Verwandten und dem Verstorbenen war. Bei verheirateten, kinderlosen Paaren erben entfernte Verwandte neben dem überlebenden Ehegatten. Bei unverheirateten Paaren erbt der überlebende Partner sogar überhaupt nichts. Zwischen mehreren Erben kommt es häufig zu Streitigkeiten, vor allem in Patchwork-Familien. Ist ein Erbe in finanziellen Schwierigkeiten oder arbeitsunfähig, wird der Staat auf das Erbe zugreifen. Aber auch in harmonischen Familien kann ein handschriftliches Testament der Eltern erhebliche Probleme auslösen, weil sich die Eltern vieler gravierender rechtlicher Folgen nicht bewusst sind und die rechtlichen Begriffe nicht zutreffend verwenden. Daher empfiehlt es sich immer, die Verteilung des Nachlasses mit einem Notar zu besprechen und ein notarielles Testament zu errichten.<br /><br />
              Befindet sich eine Immobilie im Nachlass, wird das Grundbuchamt für die Umschreibung der Immobilie auf die Erben einen Erbschein zum Nachweis der Erbfolge verlangen. Dies ist im Ergebnis meist teurer als ein notarielles Testament, zumal die Erteilung des Erbscheins oft mehrere Monate dauert und mit einem weiteren Notartermin des Erben verbunden ist. Hat der Verstorbene ein Testament beim Notar errichtet, ersetzt dieses den Erbschein. Auch aus diesem Grund bietet das notarielle Testament erhebliche Vorteile gegenüber einem handschriftlichen Testament.
            </Typography>
            <Button className='btnSecondary'><HashLink smooth to="#">Testament und Erbvertrag online abwickeln</HashLink></Button>
          </Box>

          <hr className='hoeizontalLine' />

          <Box className='subpageBodyBox'>
            <Typography variant='h2' className='sectionTitle2 subsection'>Erbe ausschlagen</Typography>
            <Typography variant='body1' className='sectionText textTwoColumns'>
              Wenn ein Mensch verstirbt, geht dessen gesamtes Vermögen automatisch auf dessen Erben über. Die Erben übernehmen auch alle Schulden des Verstorbenen. Wollen sie das Erbe nicht antreten, müssen sie die Ausschlagung des Erbes gegenüber dem Nachlassgericht erklären. Die Ausschlagungserklärung muss ein Notar beglaubigen oder die Erben müssen zum Nachlassgericht gehen. Dafür haben sie nur sechs Wochen Zeit ab dem Zeitpunkt, zu dem sie von dem Erbfall erfahren. Daher muss jeder Ausschlagende zeitnah einen Termin beim Notar oder Nachlassgericht vereinbaren.
            </Typography>
            <Button className='btnSecondary'><HashLink smooth to="#">Ausschlagung online abwickeln</HashLink></Button>
          </Box>

          <hr className='hoeizontalLine' />

          <Box className='subpageBodyBox'>
            <Typography variant='h2' className='sectionTitle2 subsection'>Erbschein beantragen</Typography>
            <Typography variant='body1' className='sectionText textTwoColumns'>
              Im Grundsatz kann ein Erbe sein Erbrecht durch Vorlage eines handschriftlichen Testaments des Verstorbenen nachweisen. Gibt es kein handschriftliches Testament, muss er sein Erbrecht durch Urkunden vom Standesamt über das Verwandtschaftsverhältnis mit dem Erblasser nachweisen. Vererbte der Verstorbene aber u.a. eine Immobilie, wird das Grundbuchamt für die Umschreibung des Eigentums auf den oder die Erben zwingend die Vorlage eines Erbscheins verlangen. Wollen die Erben die geerbte Immobilie verkaufen, müssen sie daher einen Erbschein vorlegen. Der Erbschein ist eine besondere Urkunde, die das Nachlassgericht ausstellt. Sie weist die Erbfolge offiziell nach. Der oder die Erben können entweder beim Nachlassgericht oder bei einem Notar beantragen, einen Erbschein zu erteilen.
            </Typography>
            <Button className='btnSecondary'><HashLink smooth to="#">Erbschein online beantragen</HashLink></Button>
          </Box>

          <hr className='hoeizontalLine' />

          <Box className='subpageBodyBox'>
            <Typography variant='h2' className='sectionTitle2 subsection'>Erbe unter Miterben aufteilen</Typography>
            <Typography variant='body1' className='sectionText textTwoColumns'>
              Haben mehrere Personen den Verstorbenen beerbt, entsteht eine sog. Erbengemeinschaft. Die Miterben sind gemeinsam an allen Gegenständen des Verstorbenen beteiligt. Keiner von ihnen kann allein über einen Gegenstand verfügen. Vielmehr müssen sie einstimmig beschließen, wie sie mit dem Nachlass verfahren wollen. Soll einer von ihnen Alleineigentümer eines Gegenstands werden, müssen sich die Miterben darüber auseinandersetzen. Bei Immobilien und häufig auch bei Unternehmen muss ein Notar die Auseinandersetzung beurkunden. Häufig erwirbt ein Miterbe das Alleineigentum an der Nachlassimmobilie und zahlt die anderen Miterben aus. Der Notar ermittelt zusammen mit den Beteiligten, wie eine gerechte Aufteilung des Nachlasses aussehen könnte, beurkundet die Auseinandersetzung und wickelt den Auseinandersetzungsvertrag ab.
            </Typography>
            <Button className='btnSecondary'><HashLink smooth to="#">Formular Erbauseinandersetzung</HashLink></Button>
          </Box>

        </Container>


        <Box className="section bannergrey" id="kontakt">
          <Container maxWidth="lg" className="container" id="kontakt">
            <Box className="kontaktGrid">
              <Box className="kontaktLeftSide">
                <Typography variant='h2' className='sectionTitle white'>
                  Sie haben Fragen?  <br />
                  Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                </Typography>
                <Typography variant='body1' paragraph className='whiteText'>
                  Harbecke & Thelen Notare<br />
                  Holzgasse 29 - 33<br />
                  Siegburg 53721<br />
                </Typography>
              </Box>
              <Contactform />
            </Box>
          </Container>
        </Box>


      </main >
      <Footer />
    </div >
  );
}

export default Imprint;